import * as Icons from "lucide-react";

// Renders a lucide icon by string name, falling back to a default.
export default function Icon({ name, fallback = "Link", ...props }) {
  const Cmp = Icons[name] || Icons[fallback] || Icons.Link;
  return <Cmp {...props} />;
}

export const TYPE_META = {
  website: { label: "Website", icon: "Globe" },
  webapp: { label: "Web App", icon: "AppWindow" },
  mobile: { label: "Mobile App", icon: "Smartphone" },
  drive: { label: "Drive", icon: "HardDrive" },
  tool: { label: "Tool", icon: "Wrench" },
  other: { label: "Link", icon: "Link" },
};
